// extracted by mini-css-extract-plugin
export default {"icon":"ws2yOIF3lr_landings"};